import axios from "axios";
import router from "@/routes/router";
import nprogress from "@/helpers/nprogress";
import store from "@/store";
import { AuthLogout } from "@/store/actions/auth";

import Swal from "sweetalert2";

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_API,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json"
  }
});

const requestInterceptor = config => {
  nprogress.start();
  config.headers["Authorization"] = `Bearer ${localStorage.getItem(
    "user-token"
  )}`;
  return config;
};

const responseInterceptor = response => {
  nprogress.done();
  return response;
};

const errorInterceptor = error => {
  nprogress.done();

  if (
    error.config.hasOwnProperty("errorHandle") &&
    error.config.errorHandle === false
  ) {
    return Promise.reject(error);
  }

  if (error.response) {
    switch (error.response.status) {
      case 401:
        store.dispatch(AuthLogout);
        router.push("Login", () => {});
        break;
    }

    let message = "";

    if (typeof error.response.data.message === "object") {
      let errors = Object.values(error.response.data.message).flat();
      message = errors
        .map(err => '<p class="text-danger">' + err + "</p>")
        .join("");
    } else {
      message =
        '<p class="text-danger">' + error.response.data.message + "</p>";
    }

    Swal.fire({
      icon: "error",
      title: "API Error | Hmmm!",
      html: message
    });
  } else {
    Swal.fire({
      icon: "error",
      title: "API Error | Hmmm!",
      text: error
    });
  }
};

httpClient.interceptors.request.use(requestInterceptor, undefined);
httpClient.interceptors.response.use(responseInterceptor, errorInterceptor);

export default httpClient;
